import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
  label?: string;
  showPercentage?: boolean;
  showCount?: boolean;
  variant?: 'primary' | 'success' | 'danger' | 'warning';
  size?: 'sm' | 'md' | 'lg';
  animated?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  current,
  total,
  label,
  showPercentage = true,
  showCount = true,
  variant = 'primary',
  size = 'md',
  animated = true,
}) => {
  const percentage = total > 0 ? Math.min(100, Math.round((current / total) * 100)) : 0;

  return (
    <div className={`progress-wrapper progress-${size}`}>
      {(label || showCount) && (
        <div className="progress-header">
          {label && <span className="progress-label">{label}</span>}
          <span className="progress-stats">
            {showCount && <span className="progress-count">{current} / {total}</span>}
            {showPercentage && <span className="progress-percent">{percentage}%</span>}
          </span>
        </div>
      )}
      <div className="progress-track">
        <div
          className={`progress-fill progress-${variant} ${animated ? 'progress-animated' : ''}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
